import { type FC } from "react";
import { Radio, type RadioChangeEvent } from "antd";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import "./style.less";

export interface ApplicationToggleOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

export interface ApplicationToggleProps {
  title?: string;
  options: ApplicationToggleOption[];
  value?: string | number;
  onChange?: (value: string | number) => void;
  className?: string;
}

const ApplicationToggle: FC<ApplicationToggleProps> = ({
  title,
  options,
  value,
  onChange,
  className,
}) => {
  const { t } = useTranslation();

  const handleChange = (e: RadioChangeEvent): void => {
    onChange?.(e.target.value);
  };

  return (
    <div
      className={`rd-application-toggle ${className ?? ""}`}
      data-testid="application-toggle"
    >
      <span className="rd-application-toggle__title">
        {title ??
          formatTranslation(t("newRatesAndDosage.applicationToggle.title"))}
      </span>
      <Radio.Group
        className="rd-application-toggle__group"
        options={options}
        value={value}
        optionType="button"
        buttonStyle="solid"
        onChange={handleChange}
      />
    </div>
  );
};

export default ApplicationToggle;
